export default __webpack_public_path__ + "static/1870-8651c37c317421718887978d00e4ad01.gif";